import React from 'react';

const Gallery = () => {
  return (
    <section id="gallery" className="py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-accent font-medium tracking-widest uppercase text-sm mb-2">Visual Inspiration</p>
          <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold">Our Sample Work</h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-6"></div>
        </div>
        
        <div className="relative w-full overflow-hidden rounded-lg shadow-xl bg-white border border-gray-100" style={{ minHeight: '600px' }}>
          <figure className="absolute inset-0 w-full h-full p-2 md:p-4">
            <iframe 
              src="https://media.publit.io/file/ncrinter" 
              scrolling="yes" 
              className="w-full h-full border-0 rounded-md"
              allowFullScreen={true}
              title="Our Sample Work"
            ></iframe>
          </figure>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-gray-500 text-sm italic">Explore our latest design completions and site progress.</p>
        </div>
      </div>
    </section>
  );
};

export default Gallery;